
import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowRight } = FiIcons;

const ServiceCard = ({ icon, title, description, features }) => {
  return (
    <motion.div
      whileHover={{ y: -5 }}
      className="bg-white rounded-xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300"
    >
      <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-brand-blue to-brand-lightblue rounded-xl mb-6">
        <SafeIcon icon={icon} className="h-8 w-8 text-white" />
      </div>
      
      <h3 className="text-xl font-semibold text-brand-purple mb-4">{title}</h3>
      <p className="text-brand-blue mb-6">{description}</p>
      
      <ul className="space-y-2 mb-6">
        {features.map((feature, index) => (
          <li key={index} className="flex items-center space-x-2 text-sm text-brand-blue">
            <div className="w-1.5 h-1.5 bg-brand-orange rounded-full"></div>
            <span>{feature}</span>
          </li>
        ))}
      </ul>
      
      <button className="flex items-center space-x-2 text-brand-orange font-medium hover:text-secondary-500 transition-colors">
        <span>Learn More</span>
        <SafeIcon icon={FiArrowRight} className="h-4 w-4" />
      </button>
    </motion.div>
  );
};

export default ServiceCard;
